import type { ReactNode } from 'react'

interface MeiucaLogoProps {
  /** Classes applied to the wrapper (controls gap, alignment). */
  className?: string
  /** Classes applied to the symbol SVG. Color via `text-*` (uses currentColor). */
  symbolClassName?: string
  /** Render the "Meiuca" wordmark next to the symbol. */
  showWordmark?: boolean
  /** Custom wordmark node (e.g. for dark backgrounds). Falls back to the default. */
  wordmark?: ReactNode
}

/**
 * Official Meiuca brand mark — the twin-stroke symbol from `public/favicon.svg`,
 * with an optional "Meiuca" wordmark. The symbol uses `currentColor`, so set its
 * color through `symbolClassName` (e.g. `text-brand-primary`).
 */
export function MeiucaLogo({
  className = '',
  symbolClassName = 'h-9 w-9 text-brand-primary',
  showWordmark = true,
  wordmark,
}: MeiucaLogoProps) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <svg viewBox="0 0 100 100" role="img" aria-label="Meiuca" className={symbolClassName}>
        <path d="M 12 84 L 12 22 Q 12 14 19 19 L 44 60 Q 46 63 46 67 L 46 80 Q 46 84 42 84 Z" fill="currentColor" />
        <path d="M 88 84 L 88 22 Q 88 14 81 19 L 56 60 Q 54 63 54 67 L 54 80 Q 54 84 58 84 Z" fill="currentColor" />
      </svg>
      {showWordmark &&
        (wordmark ?? <span className="text-xl font-bold text-text-primary">Meiuca</span>)}
    </span>
  )
}
